import React, { useState } from "react";
import { maskEmail, maskPhone } from "./Utility";

const MaskTableRow = (props) => {
  const [isShow, setIsShow] = useState({ email: false, phone_number: false });

  return (
    <tr className="masktable">
      <td>{props.name}</td>
      {/* <td>{con.designation}</td> */}
      <td className="email">
        <React.Fragment>
          {maskEmail(props.email, 2, "email")}
          {/* <i className="fa fa-eye" onClick={showEmailValue}></i> */}
        </React.Fragment>
      </td>
      <td className="email">
        <React.Fragment>
          {maskPhone(props.phone_number, 3) || "--"}{" "}
          {/* <i className="fa fa-eye" onClick={showPhoneValue}></i> */}
        </React.Fragment>
      </td>
      <td>
        <ul>
          {props.is_edit !== false ||
            (props.crmpermission === 1 && (
              <React.Fragment>
                <li>
                  <a
                    data-toggle="modal"
                    data-target="#edit"
                    onClick={() => props.contactEditHandler(props.index)}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1390_14481)">
                        <path
                          d="M11.3333 2.00004C11.5083 1.82494 11.7162 1.68605 11.945 1.59129C12.1738 1.49653 12.419 1.44775 12.6666 1.44775C12.9142 1.44775 13.1594 1.49653 13.3882 1.59129C13.617 1.68605 13.8248 1.82494 13.9999 2.00004C14.175 2.17513 14.3139 2.383 14.4087 2.61178C14.5034 2.84055 14.5522 3.08575 14.5522 3.33337C14.5522 3.58099 14.5034 3.82619 14.4087 4.05497C14.3139 4.28374 14.175 4.49161 13.9999 4.66671L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2.00004Z"
                          stroke="#5C5F62"
                          stroke-width="1.33"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_1390_14481">
                          <rect width="16" height="16" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    data-toggle="modal"
                    data-target="#warning"
                    onClick={() => props.showDeleteHandler(props.email)}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 4H3.33333H14"
                        stroke="#5C5F62"
                        stroke-width="1.33"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M5.33325 3.99992V2.66659C5.33325 2.31296 5.47373 1.97382 5.72378 1.72378C5.97383 1.47373 6.31296 1.33325 6.66659 1.33325H9.33325C9.68687 1.33325 10.026 1.47373 10.2761 1.72378C10.5261 1.97382 10.6666 2.31296 10.6666 2.66659V3.99992M12.6666 3.99992V13.3333C12.6666 13.6869 12.5261 14.026 12.2761 14.2761C12.026 14.5261 11.6869 14.6666 11.3333 14.6666H4.66659C4.31296 14.6666 3.97382 14.5261 3.72378 14.2761C3.47373 14.026 3.33325 13.6869 3.33325 13.3333V3.99992H12.6666Z"
                        stroke="#5C5F62"
                        stroke-width="1.33"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M6.66675 7.33325V11.3333"
                        stroke="#5C5F62"
                        stroke-width="1.33"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M9.33325 7.33325V11.3333"
                        stroke="#5C5F62"
                        stroke-width="1.33"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </a>
                </li>
              </React.Fragment>
            ))}
        </ul>
      </td>
    </tr>
  );
};

export default MaskTableRow;



// WEBPACK FOOTER //
// ./src/components/crm/customer/MaskTableRow.js